import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Route, Router } from '@angular/router';
import { AuthService } from '../../../../core/auth.service';
import { SharedService } from '../../shared.service';
import { EncryptionService } from '../../../services/encryption.service';
import { UpperCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-callcenter-navbar',
    imports: [UpperCasePipe, FormsModule, RouterLink],
    templateUrl: './callcenter-navbar.component.html',
    styleUrl: './callcenter-navbar.component.scss',})
export class CallcenterNavbarComponent {
  isMobileSearch: boolean = false;
  username: string | null = '';
  userType: string | null = '';

  constructor(private sharedService: SharedService, private authService: AuthService, private router: Router,private encryptionService: EncryptionService
  ) {
  }

  ngOnInit(): void {
    // Retrieve username and user_type from localStorage
    this.username = this.encryptionService.getFromLocalStorage('username');
    this.userType = this.encryptionService.getFromLocalStorage('user_type');
  }
  
  SerachMbInfo() {
    this.isMobileSearch = !this.isMobileSearch
  }
  ngDocheck() {
    this.detectMobileView(false);
    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
  }
  detectMobileView(val: boolean) {
    // alert("okay")
    this.sharedService.toggleClass(val);
    // this.isMobile=val;
    // this.isMobileView = window.innerWidth <= 768; // Example: mobile is defined as screen width <= 768px
  }
  logout() {
    // Implement logout logic
    this.authService.logout();
  }

  shouldHideButton(): boolean {
    return this.router.url.includes('/tml/order');
  }

    createVasorder(val: boolean): any {
    // this.sharedService.toggleCreateorderClass(val);
    this.router.navigate(['/callcenter/order/enquiry']);

  }
}
